export const classNames = (classes: { [key: string]: boolean }): string => {
    return Object.keys(classes)
        .filter((key) => classes[key])
        .join(' ');
};
